import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {SignalEntityQuery} from 'src/app/modules/shared/state/signal-entity.store';
import {ItemState, ItemStore} from './item.store';
import {Item} from 'src/app/modules/shared/models/policy.model';

@Injectable({providedIn: 'root'})
export class ItemQuery extends SignalEntityQuery<Item, ItemState> {
    constructor(protected store: ItemStore) {
        super(store);
    }

    getItems(): Observable<any> {
        return this.selectAll();
    }
}
